import { Form, Input, Modal } from 'antd';
import { useEffect, useState } from 'react';

import { AdminQuestionModule } from '@/types/apis/admin';

type QuestionModule = AdminQuestionModule;

type Props = {
  isOpen: boolean;
  module?: QuestionModule | null;
  onClose: () => void;
  onSave: (
    module:
      | QuestionModule
      | Omit<AdminQuestionModule, 'id' | 'createdAt' | 'updatedAt'>,
  ) => void;
  mode: 'add' | 'edit';
};

export default function QuestionModuleModal({
  isOpen,
  module,
  onClose,
  onSave,
  mode,
}: Props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      if (mode === 'edit' && module) {
        form.setFieldsValue({
          name: module.name,
        });
      } else if (mode === 'add') {
        form.resetFields();
      }
    }
  }, [mode, module, isOpen, form]);

  const handleSave = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      if (mode === 'edit' && module) {
        onSave({ ...module, ...values });
      } else {
        onSave(
          values as Omit<AdminQuestionModule, 'id' | 'createdAt' | 'updatedAt'>,
        );
      }
      onClose();
    } catch (error) {
      console.error('Form validation failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={mode === 'edit' ? '編輯問題模組' : '新增問題模組'}
      open={isOpen}
      onOk={handleSave}
      onCancel={handleCancel}
      okText={mode === 'edit' ? '更新' : '新增'}
      cancelText="取消"
      width={500}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item
          label="模組名稱"
          name="name"
          rules={[
            { required: true, message: '請輸入模組名稱' },
            { max: 100, message: '模組名稱不能超過100個字符' },
          ]}
        >
          <Input placeholder="輸入問題模組名稱" maxLength={100} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
